import { render, staticRenderFns } from "./CreateCategory.vue?vue&type=template&id=2ba3c095&"
import script from "./CreateCategory.vue?vue&type=script&lang=js&"
export * from "./CreateCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports